/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type { AppIconSlots, AppIconState } from "./AppIcon.types";
import { assertSlots } from "@fluentui/react-components";

export const renderAppIcon = (state: AppIconState) => {
  assertSlots<AppIconSlots>(state);

  return (
    <state.root data-icon-name={state.iconName}>{state.children}</state.root>
  );
};
